// removed by extract-text-webpack-plugin
module.exports = {"component":"_2ZgtrMD4eVWXQO-Bs3LYiU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Widget/MultiStep/multiStep.css
// module id = 477
// module chunks = 2